import {
  AuthorizeView,
  Button,
  TextInput,
  Unform,
  Loading,
  TextAreaInput,
  AddObservation,
  AutocompleteInput,
  SelectInput,
} from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext, useState, useEffect, useMemo } from 'react';
import { Flex, Box, Stack, Heading } from '@chakra-ui/react';
import { SubmitHandler } from '@unform/core';

import { ALICtx } from 'pages';

import { getCommonProps } from 'utils/CommonPropperties';
import { checkPermission } from 'utils/authentication';
import { getAllClients } from 'services/client';
import ALI from 'models/Forms/ALI';
import { getLoggedUser } from 'utils/storage';

type ClientProps = {
  name: string;
  id: React.ReactText;
};

interface IProps extends BodyProps {}
const Item: React.FC<IProps> = ({ functionCallback, index, submit, completed }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [clients, setClients] = useState<{ name: string; id: React.ReactText }[]>([]);
  const ctx = useContext(ALICtx);

  const cProps = useMemo(() => getCommonProps(ctx.isDetails), [ctx.isDetails]);

  useEffect(() => {
    if (checkPermission({ onlyAdmin: true })) {
      (async () => {
        const { data } = await getAllClients('');
        setClients(data);
      })();
    }
  }, []);

  useEffect(() => {
    if (ctx.isDetails && clients.length > 0) {
      if (ctx.setClient) ctx.setClient(clients.find(i => i.id === ctx.data.clientId));
    }
  }, [ctx.isDetails, clients]);

  const handleSubmit = useCallback<SubmitHandler<ALI>>(
    async data => {
      setLoading(true);
      if (submit) {
        const resp = await submit(data, '1 - Conceitos relevantes e descrição da atividade');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [submit, functionCallback],
  );

  const clientSelect = clients.find(i => +i.id === +(getLoggedUser().client || '')) as ClientProps;
  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform initialData={ctx.data} onSubmit={handleSubmit}>
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box>
              {!ctx.isDetails && (
                <AuthorizeView onlyAdmin>
                  {clients.length > 0 ? (
                    !getLoggedUser()?.client ? (
                      <AutocompleteInput
                        name="clientId"
                        optionLabel="name"
                        optionValue="id"
                        label="Cliente"
                        options={
                          clients
                            ?.map(client => ({ name: client.name, id: client.id }))
                            .sort((a, b) => {
                              return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                            }) || []
                        }
                      />
                    ) : (
                      <SelectInput
                        name="clientId"
                        optionLabel="name"
                        optionValue="id"
                        label="Cliente"
                        options={
                          clients
                            ?.map(client => ({ name: client.name, id: client.id }))
                            .sort((a, b) => {
                              return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                            }) || []
                        }
                        defaultValues={[clientSelect]}
                        {...cProps}
                        disabled
                      />
                    )
                  ) : (
                    <Loading />
                  )}
                </AuthorizeView>
              )}
              {ctx.isDetails && (
                <AuthorizeView onlyAdmin>
                  {clients.length > 0 ? (
                    <SelectInput
                      name="clientId"
                      optionLabel="name"
                      optionValue="id"
                      label="Cliente"
                      options={
                        clients
                          ?.map(client => ({ name: client.name, id: client.id }))
                          .sort((a, b) => {
                            return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                          }) || []
                      }
                      defaultValues={[clientSelect]}
                      {...cProps}
                      disabled
                    />
                  ) : (
                    <Loading />
                  )}
                </AuthorizeView>
              )}

              <Heading
                mt={checkPermission({ onlyAdmin: true }) && !ctx.isDetails ? '2rem' : undefined}
                mb="1rem"
                size="xs"
                as="p"
              ></Heading>
              <Box
                borderRadius={4}
                mb="24px"
                border="1px solid"
                borderColor="brand.gray600"
                padding="16px"
                boxShadow="0px 5px 15px rgba(0, 0, 0, 0.1)"
                __css={{
                  fontSize: '14px',
                  color: 'brand.1400',
                  '& b': {
                    color: 'brand.tertiary',
                  },
                }}
              >
                <p>
                  <b>Dado Pessoal:</b> qualquer informação que possa levar à identificação de uma
                  pessoa, seja de maneira direta ou indireta. Inclui: dados cadastrais, hábitos,
                  preferências, histórico de consumo, dados bancários e financeiros, logs e
                  registros eletrônicos, geolocalização, IP de conexão etc
                </p>
                <br />
                <p>
                  <b>Titular:</b> pessoa física a que se referem os dados pessoais
                </p>
                <br />
                <p>
                  <b> Tratamento:</b> qualquer atividade praticada com dados pessoais. Inclui:
                  acesso, coleta, visualização, compartilhamento, exclusão, armazenamento etc
                </p>
                <br />
              </Box>
            </Box>
            <Box
              __css={{
                '& b': {
                  color: 'brand.tertiary',
                },
              }}
              mt="13px"
            >
              <b> Descrição da atividade</b>
              <br />
              <br />
              <TextInput
                mt="8px"
                name="name"
                label="Identificação da Atividade"
                // {...cProps}
              />
              <TextAreaInput
                mt="8px"
                name="concreteSituation"
                label="Descreva a situação concreta que demanda o tratamento de dados e como esse tratamento ocorrerá"
                // {...cProps}
              />
            </Box>
            <Box mt="13px">
              <TextAreaInput
                mt="8px"
                name="personalData"
                label="Liste todos os dados pessoais que serão utilizados nesta atividade"
                // {...cProps}
              />
            </Box>
            <Box mb="24px">
              <Box mt="8px">
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder={'Observações sobre o tratamento de dados (opcional)'}
                  obsValue={
                    ctx.data.jsonCustomObsObj
                      ? ctx.data.jsonCustomObsObj.processingOfRelevantConceptsAndActivity
                      : ''
                  }
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        processingOfRelevantConceptsAndActivity: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box>
              {!ctx.isDetails && (
                <AuthorizeView onlyAdmin>
                  {clients.length > 0 ? (
                    <AutocompleteInput
                      name="clientId"
                      optionLabel="name"
                      optionValue="id"
                      label="Cliente"
                      options={clients}
                    />
                  ) : (
                    <Loading />
                  )}
                </AuthorizeView>
              )}
              <Heading
                mt={checkPermission({ onlyAdmin: true }) && !ctx.isDetails ? '2rem' : undefined}
                mb="1rem"
                size="xs"
                as="p"
              ></Heading>
              <Box
                borderRadius={4}
                mb="24px"
                border="1px solid"
                borderColor="brand.gray600"
                padding="16px"
                boxShadow="0px 5px 15px rgba(0, 0, 0, 0.1)"
                __css={{
                  fontSize: '14px',
                  color: 'brand.1400',
                  '& b': {
                    color: 'brand.tertiary',
                  },
                }}
              >
                <p>
                  <b>Dado Pessoal:</b> qualquer informação que possa levar à identificação de uma
                  pessoa, seja de maneira direta ou indireta. Inclui: dados cadastrais, hábitos,
                  preferências, histórico de consumo, dados bancários e financeiros, logs e
                  registros eletrônicos, geolocalização, IP de conexão etc
                </p>
                <br />
                <p>
                  <b>Titular:</b> pessoa física a que se referem os dados pessoais
                </p>
                <br />
                <p>
                  <b> Tratamento:</b> qualquer atividade praticada com dados pessoais. Inclui:
                  acesso, coleta, visualização, compartilhamento, exclusão, armazenamento etc
                </p>
                <br />
              </Box>
            </Box>
            <Box
              __css={{
                '& b': {
                  color: 'brand.tertiary',
                },
              }}
              mt="13px"
            >
              <b> Descrição da atividade</b>
              <br />
              <br />
              <TextInput
                mt="8px"
                name="name"
                label="Identificação da Atividade"
                isDisabled={completed}
              />
              <TextAreaInput
                mt="8px"
                name="concreteSituation"
                label="Descreva a situação concreta que demanda o tratamento de dados e como esse tratamento ocorrerá"
                isDisabled={completed}
              />
            </Box>
            <Box mt="13px">
              <TextAreaInput
                mt="8px"
                name="personalData"
                label="Liste todos os dados pessoais que serão utilizados nesta atividade"
                isDisabled={completed}
              />
            </Box>
            <Box mb="24px">
              <Box mt="8px">
                <AddObservation
                  isDetail={completed}
                  placeholder={'Observações sobre o tratamento de dados (opcional)'}
                  obsValue={
                    ctx.data.jsonCustomObsObj
                      ? ctx.data.jsonCustomObsObj.processingOfRelevantConceptsAndActivity
                      : ''
                  }
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        processingOfRelevantConceptsAndActivity: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};
export const RelevantConceptsAndActivity = memo(Item);
